export default __webpack_public_path__ + "static/media/img_3.9fd4ac53.JPG";